{
  "name": "SacpolCancun",
  "version": "1.3.33",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:dev": "ng build -c development",
    "watch": "ng build --watch --configuration development",
    "source": "source-map-explorer dist/SacpolCancun/browser/main-*.js",
    "test": "jest --coverage=false",
    "test:coverage": "jest"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.5",
    "@angular/cdk": "^21.1.5",
    "@angular/common": "^21.1.5",
    "@angular/compiler": "^21.1.5",
    "@angular/core": "^21.1.5",
    "@angular/forms": "^21.1.5",
    "@angular/material": "^21.1.5",
    "@angular/platform-browser": "^21.1.5",
    "@angular/platform-browser-dynamic": "^21.1.5",
    "@angular/router": "^21.1.5",
    "@here/maps-api-for-javascript": "^2.4.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "amazon-quicksight-embedding-sdk": "^2.11.3",
    "angularx-qrcode": "^21.0.4",
    "chart.js": "^4.5.0",
    "dayjs": "^1.11.13",
    "dayjs-plugin-utc": "^0.1.2",
    "file-saver": "^2.0.5",
    "jszip": "^3.10.1",
    "lottie-web": "^5.13.0",
    "ng2-charts": "^9.0.0",
    "ng2-file-upload": "^9.0.0",
    "ngx-file-drop": "^16.0.0",
    "ngx-lottie": "^21.2.0",
    "ngx-mat-timepicker": "^21.0.0",
    "ngx-webcam": "^0.4.1",
    "qrcode": "^1.5.4",
    "rxjs": "^7.8.2",
    "swiper": "^12.1.2",
    "timezone": "^1.0.23",
    "tslib": "^2.8.1",
    "zone.js": "^0.16.1"
  },
  "devDependencies": {
    "@angular-builders/jest": "^20.0.0",
    "@angular/build": "^21.1.5",
    "@angular/cli": "^21.1.5",
    "@angular/compiler-cli": "^21.1.5",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.0",
    "@types/jest": "^30.0.0",
    "@types/node": "^22.15.32",
    "@types/qrcode": "^1.5.5",
    "autoprefixer": "^10.4.20",
    "jest": "^30.0.0",
    "jest-preset-angular": "^14.6.0",
    "postcss": "^8.4.49",
    "tailwindcss": "^3.4.19",
    "typescript": "5.9.3"
  }
}
